/**
 * Set of 11 colors which can be used as to assign unqiue colors to represent unique entities.
 */
export const RANDOM_COLOR_PALETTE = [
  "#FF8080",
  "#CC80FF",
  "#808EFF",
  "#949398",
  "#496076",
  "#5b84b0",
  "#80BDFF",
  "#67C1BF",
  "#69CE7D",
  "#97C90D",
  "#F0A53D",
];
